import {Class} from "./utils";

/**
 *
 * @class Result
 * @classdesc A single result from a searcher. May represent either a real result or a new query. Only Searchers will create instances of Result
 * 
 */
export default Class(
  {
    /**
     This result's type
     @name Result#type
     @type String
     @readonly
     */
    type: null,
    /**
     This result's source
     @name Result#source
     @type String
     @readonly
     */
    source: null,
    /**
     This result's title
     @name Result#title
     @type String
     @readonly
     */
    title: null,
    /**
     This result's description
     @name Result#description
     @type String
     @readonly
     */
    description: null,
    /**
     This result's geometry (GeoJson geometry)
     @name Result#geometry
     @type Object
     @readonly
     */
    geometry: null,
    /**
     This result's data (As returned from underlying service or data)
     @name Result#data
     @type Object
     @readonly
     */
    data: null,
    /**
     This result's searcher
     @name Result#searcher
     @type Object
     @readonly
     */
    searcher: null,
    /**
     This result's image url
     @name Result#image
     @type String
     @readonly
     */
    image: null,
    /**
     This newquery suggestion
     @name Result#newquery
     @type String
     @readonly
     */
    newquery: null,
    /**
     This result's distance from other result
     @name Result#source
     @type float
     @readonly
     */
    distance: null,
    /**
     This result's route
     @name Result#route
     @type Object
     @readonly
     */
    route: null,
    isComplete: true,
    
    initialize: function (options) {
      Object.assign(this, options);
    },
    
    isNewQuery: function () {
      return typeof this.newquery !== 'undefined' && this.newquery !== null;
    },
    
    complete: async function(){
      if (this.isComplete || this.searcher === null){
        return this;
      }else{
        return this.searcher.completeResult(this);
      }
    },

    CLASS_NAME: 'Septima.Search.Result'
  }
)